import "./topbar.scss";
import React from "react";
import { Call, Mail } from "@material-ui/icons";
import Facebook from "@material-ui/icons/Facebook";
import LinkedIn from "@material-ui/icons/LinkedIn";
import GitHub from "@material-ui/icons/GitHub";
import Twitter from "@material-ui/icons/Twitter";
import NightlightIcon from "@mui/icons-material/Nightlight";
import LightModeIcon from "@mui/icons-material/LightMode";

export default function Topbar({ menuOpen, setMenuOpen ,darkMode,toggleDarkMode }) {
  return (
    <div className={`topbar ${(menuOpen ? "active": "")} ${darkMode? 'light': 'dark'}`}>
      <div className="wrapper">
        <div className="left">
          <a href="#intro" className="logo">
            Mohanad.
          </a>
          <div className="itemContainer">
            <a href="tel:+20 1022944586">
     
              <Call className="icon" />
              <span>+20 1022944586</span>
            </a>
          </div>
          <div className="itemContainer">
            <a href="mailto:mohanadsafwat@icloud.com">

              <Mail className="icon" />
              <span>mohanadsafwat@icloud.com</span>
            </a>
          </div>
        </div>
        <div className="middle">
          <a
            href="https://www.facebook.com/MuhanadSafwat"
            target="_blank"
            rel="noreferrer"
          >
            <Facebook className="facebook" />
          </a>
          <a
            href="https://www.linkedin.com/in/mohanadsafwat"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedIn className="linkedin" />
          </a>
          <a
            href="https://www.github.com/MohanadSafwat"
            target="_blank"
            rel="noreferrer"
          >
            <GitHub className="github" />
          </a>
          <a
            href="https://www.twitter.com/MuhanadSafwat"
            target="_blank"
            rel="noreferrer"
          >
            <Twitter className="twitter" />
          </a>
        </div>

        <div className="right">
          <div className="nightMode">
            {darkMode ? <NightlightIcon  onClick={() => {
              toggleDarkMode();
            }} /> :
            <LightModeIcon  onClick={() => {
              toggleDarkMode();
            }}/>}
          </div>
          <div
            className="burger"
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          >
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
